"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CheckInStatus;
(function (CheckInStatus) {
    CheckInStatus[CheckInStatus["DID_EARLIER_TODAY"] = 0] = "DID_EARLIER_TODAY";
    CheckInStatus[CheckInStatus["JUST_DID_IT"] = 1] = "JUST_DID_IT";
    CheckInStatus[CheckInStatus["ALL_DONE"] = 2] = "ALL_DONE";
    CheckInStatus[CheckInStatus["NO_EVALUATION"] = 3] = "NO_EVALUATION";
})(CheckInStatus = exports.CheckInStatus || (exports.CheckInStatus = {}));
//# sourceMappingURL=checkIn.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/checkIn.js
// module id = 995
// module chunks = 0